<input
  #input
  type="text"
  [placeholder]="placeHolder"
  [(ngModel)]="inputValue"
  (input)="onInput()" />
